import React from 'react';
import {Link} from "@reach/router";

const SocialButtons = () => {
  return (
    <div className="social-buttons d-flex justify-content-between d-md-block">
      <div className="mb-5">
        <span>Follow us</span>
        <div className="icons d-flex justify-content-between">
          <a href="https://www.facebook.com/payondelivery" target="_blank" rel="noopener noreferrer">
            <img src="/images/v2/fb-footer-icon.svg" alt="PayOnDelivery on Facebook"/>
          </a>
          <a href="https://www.linkedin.com/company/payondelivery/" target="_blank" rel="noopener noreferrer">
            <img src="/images/v2/linkedin-footer-icon.svg" alt="PayOnDelivery on LinkedIn"/>
          </a>
          <a href="https://www.instagram.com/payondelivery" target="_blank" rel="noopener noreferrer">
            <img src="/images/v2/instagram-footer-icon.svg" alt="PayOnDelivery on Instagram"/>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SocialButtons;
